import * as React from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Input, Label, Row } from 'reactstrap';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, DimensionReference, FactTable, generateAffiliateNoDataState, generateLocalStateFromEventProperties,
    getSelectedAfr, getTable, updateAffiliateNoData, updateVersionStateValue
} from '../../redux/AfrSlice';
import { Concept, loadConcept } from '../../redux/ConceptSlice';
import { getSectionDimensionMap, setIsDirty } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { ErrorGrid, updateSupplementalGridErrors, updateSingleSupplementalGridError, removeSingleSupplementalGridError } from '../../redux/ValidationSlice';
import dateHelper from '../../utils/dateHelper';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import { ShowSupplementalGridErrorList } from './ShowSupplementalGridErrorList';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';


const RowDimensionEditorGrid = (props: {
    componentTitle: string;
    tableName: string,
    affiliateCode: string,
    noDataState: string,
    gridData: any[],
    gridColumns: any[],
    gridOptions: any,
    gridId: string,
    dimensionFilter: Concept[],
    taxonomyType: TaxonomyTypeEnum
    noData: any,
    updateHasFacts: (newState : any) => void;
}) => {
    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();
    /* ************************************** Modal section ************************************/



    const parameters = useLocation();
    const firstFieldId = "FG_001_GeneralFundMember";
    var tabulatorRef = React.useRef<any>();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const [checkBoxState, setCheckboxState] = useState(false);
    const [state, setState] = useState(props.noData) //useState(props.affiliateCode ? generateAffiliateNoDataState(currentAfr, props.affiliateCode, props.noDataState) : generateLocalStateFromEventProperties(currentAfr, [props.noDataState]));
    let title: string = props.componentTitle;
    const [lastErrorValue, setLastErrorValue] = useState<string | null>(null);
    const [lastError, setLastError] = useState<ErrorGrid | null>(null);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);

    /* ***********************************************************************************************************/
    //Events
    /* ***********************************************************************************************************/

    const isNoData = function() : boolean {
        var currentState = props.noData; //props.affiliateCode ? generateAffiliateNoDataState(currentAfr, props.affiliateCode, props.noDataState) : generateLocalStateFromEventProperties(currentAfr, [props.noDataState]);
        if (!currentState) {
            return false;
        }
        return currentState[props.noDataState] === true;
    }
    const addRowFromRow = function (e: any, row: any) {
        if (isNoData()) {
            alert("You must uncheck the No Data box to Add New Rows!")
            return;
        }
        var table = row.getTable();
        addRowGivenTable(table);
    }

    const addRowFromColumn = function (e: any, column: any) {
        if (isNoData()) {
            alert("You must uncheck the No Data box to Add New Rows!")
            return;
        }
        var table = column.getTable();
        addRowGivenTable(table);
    }

    const addRowGivenTable = function (table: any) {
        var rowDimMap = {};
        if (currentAfr) {
            var factTable = getTable(currentAfr, props.tableName);
            if (factTable) {
                rowDimMap = utilityHelper.generateNewRowDimensionMap(factTable);
            }
        }
        if (currentAfr != null) {
            var newRow = utilityHelper.createNewRowForTypeDimensionTable(currentAfr, props.tableName, rowDimMap, null);
        }

        table.addRow({ ...newRow });

        var row = table.getRowFromPosition(table.getRows().length);//table.getRowFromPosition(table.getRows().length - 1, true);

        /* save the whole table into misc slice */
        updateCell(null, table);

        showErrors(row);
    }

    var rowMenu = [
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add New Row",
            action: addRowFromRow
        }
    ];

    var headerMenu = [
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add New Row",
            action: addRowFromColumn
        }
    ];

    const handleDelete = function (e: any, cell: any) {

        if (confirm('Are you sure you want to delete this row?')) {

            var table = cell.getTable();
            cell.getRow().delete().then(function () {
                var rows = [];
                rows = table.getData();

                // Turn ON the dirty flag in redux
                dispatch(setIsDirty({ IsDirty: true, Page: "" }));
                // Track the changes on Cells to an array of facts into MiscSlice
                if (props.affiliateCode) {
                    utilityHelper.updateTablePendingFacts(props.tableName + "^" + props.affiliateCode, null, table, dispatch);
                } else {
                    utilityHelper.updateTablePendingFacts(props.tableName, null, table, dispatch);
                }
                utilityHelper.saveDeferredChanges(dispatch);
            }).catch(function (error: any) {
            });

        }

    }

    const hasData = function () {
        var returnValue = false;

        if (tabulatorRef.current && tabulatorRef.current.table) {
            var table = tabulatorRef.current.table;

            var rows = [];
            rows = table.getData();

            return (rows.length > 0);
        }

        return returnValue;
    }

    const getRowKey = function (cell: any) {
        var row = cell.getRow();
        var dataRow = row.getData();
        var key = "";

        for (var field of dataRow.dimensionFields) {
            key = key + (dataRow[field] ? dataRow[field] : "") + "|";
        }
        return key;
    }

    const numberFormatter = function (cell: any) {

        var row = cell.getRow();
        var dataType = row.getData().dataType;

        var formatted = utilityHelper.Formatter(cell.getValue(), dataType);

        return formatted;

    }

    const integerFormatter = function (cell: any) {

        var formatted = utilityHelper.Formatter(cell.getValue(), "XBRLI_NONNEGATIVEINTEGERITEMTYPE");

        return formatted;

    }

    const percentFormatter = function (cell: any) {

        var formatted = utilityHelper.Formatter(cell.getValue(), "DTR_TYPES_PERCENTITEMTYPE");

        return formatted;

    }

    const validators = function (cell: any, newValue: string, parameters: any) {
        //cell - the cell component for the edited cell
        //value - the new input value of the cell
        //parameters - the parameters passed in with the validator
        var val: string = "";
        var error: ErrorGrid | null = null;
        var row = cell.getRow();

        var value = ""
        if (!(utilityHelper.isNullOrEmpty(newValue))) {
            value = newValue;
        }

        var row = cell.getRow().getData();


        /*1 - check if field is required */
        if (value === null || value === "") {
            error = { field: cell.getField(), type: "required", message: cell.getField() + " is required." }
            return { result: false, error };
        }


        /* 2 - Validate for duplicates rows             */
        var rowDimkey = utilityHelper.getRowDimensionsKey(row, cell.getField(), newValue);
        if (utilityHelper.checkForRowDuplicates(cell.getTable(), row.key, rowDimkey)) {
            error = { field: "", type: "duplicate", message: rowDimkey + " is duplicated." }
            return { result: false, error };
        }
        var valueMap: any = {
        };
        var properties: string[] = [
            "EarliestMaturityDateAxis",
            "LatestMaturityDateAxis",
            "BondTypeAxis",
            "BondSeriesAxis"
        ];
        properties.map((p : string) => row.hasOwnProperty(p) ? valueMap[p] = row[p] : valueMap[p] = "");
        valueMap[cell.getField()] = value;
        var earliestValue = valueMap["EarliestMaturityDateAxis"];
        var earliest: string | null = null
        var latestValue = valueMap["LatestMaturityDateAxis"];
        var latest: string | null = null;
        /* 3 - validate individual dates  */
        if (!(utilityHelper.isNullOrEmpty(earliestValue))) {
            earliest = utilityHelper.convertToISODate(earliestValue).split("T")[0];
            if (!dateHelper.isValidDate(earliest)) {
                error = { field: "LatestMaturityDateAxis", type: "dates", message: "Earliest Maturity Date (" + dateHelper.stringToDateString(earliestValue) + ") is not a valid Date." }
                return { result: false, error };
            }
        }

        if (!(utilityHelper.isNullOrEmpty(latestValue))) {
            latest = utilityHelper.convertToISODate(latestValue).split("T")[0];
            if (!dateHelper.isValidDate(latest)) {
                error = { field: "LatestMaturityDateAxis", type: "dates", message: "Latest Maturity Date (" + dateHelper.stringToDateString(latestValue) + ") is not a valid Date." }
                return { result: false, error };
            }
        }

        /* 3 - validate dates  */
        if (earliest && latest) {
            if (earliest > latest) {
                error = { field: "EarliestMaturityDateAxis", type: "dates", message: "Earliest Maturity Date (" + dateHelper.stringToDateString(earliest) + ") cannot be greater than Latest Maturity Date (" + dateHelper.stringToDateString(latest) + ")." }
                return { result: false, error };
            }
        }
        /* TODO - Add further immediate validations */

        /* ******************************************** */
        return { result: true, error };
    }

    const processEndEditValidations = function (cell: any) {
        var value = cell.getValue();
        const { result, error } = validators(cell, value, null);
        if (!result && error) {
            var modError = { ...error, message: error.message };
            dispatch(updateSingleSupplementalGridError(modError));
            return;
        }
        dispatch(removeSingleSupplementalGridError({ field: "", message: "(editing)" }));
    }

    const handleCancelEdit = function (cell: any) {
        dispatch(removeSingleSupplementalGridError({ field: "", message: "(editing)" }));
    }


    const customValidator = function (cell: any, value: any, parameters: any) {
        const { result, error } = validators(cell, value, parameters);
        if (!result && error) {
            var cellData = cell.getValue();
            if (value !== cellData) {
                var modError = { ...error, message: error.message + " (editing)" };
                dispatch(updateSingleSupplementalGridError(modError));
            }
        }
        return result;
    }

    // here we can send the errors to the error notifier
    const handleValidationFailed = function (cell: any, value: any, validators: any) {
        //cell - cell component for the edited cell
        //value - the value that failed validation
        //validatiors - an array of validator objects that failed
        console.log("Validation Failed: >>", cell.getField(), "<< old value:", cell.getOldValue(), " new value: ", value, validators);
    }

    const showDelete = function (cell: any, formatterParams: any, onRendered: any) {

        return "<i class='bi bi-trash-fill text-danger' title='Click here to delete the row'></i>";

    };

    const showIcons = function (cell: any, formatterParams: any, onRendered: any) {

        var row = cell.getRow();

        var valid = row.validate();
        if (valid === true) {
            // Check the actual data
            var rdata = row.getData();
        }
        if (valid === true) {
            return " <i class='bi bi-check-circle-fill text-success'</i>";
        } else {
            return " <i class='bi bi-x-octagon-fill text-danger' title='Click on the row to see all the errors'></i>";
        }

    };

    const showErrors = function (row: any) {

        var valid = row.validate();
        var cellsWithError : any[] = [];
        var errors: Array<ErrorGrid> = [];

        if (valid === true) {
            console.log("No Errors");
        } else {
            cellsWithError = valid;
            for (var cellError of cellsWithError) {

                var value : any = cellError.getValue();
                const { result, error } = validators(cellError, value, null);

                if (error) {
                    errors.push(error);
                }
            }

        }

        /* remove duplicated errors */

        if (errors.length > 0) {
            var packedErrors: Array<ErrorGrid>;
            packedErrors = utilityHelper.removeDuplicatesFromArray(errors);
            errors = JSON.parse(JSON.stringify(packedErrors));
        }

        dispatch(updateSupplementalGridErrors(errors));

    }

    const handleChangeCheckbox = function (event: any) {

        var value: boolean = event.target.checked;
        var key = props.noDataState;
        var newState: any = { ...props.noData };
        newState[key] = value;

        setState(newState);
        // call to dispatcher by sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]


        // Update global flag for this event in redux
        if (props.affiliateCode) {
            dispatch(updateAffiliateNoData({ affiliate: props.affiliateCode, propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value }));
        } else {
            dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));
        }
        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))

        /* This part should be replaced it by a call to redux to save this state into Misc or AFR instead of a local state.  
           Performing this approach avoids that the grid constantly is refreshed when the check box is clicked */
        setCheckboxState(value);
//        props.updateNoData(newState);

    }

    const handleCellClick = function (e: any, cell: any) {

        var row = cell.getRow();

        if (row._row.type != "row") { return }

        setLastErrorValue(null);
        setLastError(null);

        // This is a column-concept table, so the field will be the concept id
        var cId = cell.getField();
        if (cId) {
            dispatch(loadConcept({
                conceptId: cId,
                taxonomyType: currentAfr ? currentAfr.taxonomyType : TaxonomyTypeEnum.AFR,
                afrYear: currentAfr ? currentAfr.year : 2022
            }));
        }

    }

    const handleRowClick = function (e: any, row: any) {
        //e - the click event object
        //row - row component
        if (row._row.type != "row") { return }

        showErrors(row);
        // row.getTable().deselectRow();
        //row.select();
    }


    // logic to handle the dirty flag in redux store
    const handleEdited = function (cell: any) {

        var newValue: string = cell.getValue();
        var rowData: any = cell.getRow().getData();
        var field: string = cell.getField();
        newValue = newValue.trim();
        var prevEffectiveValue: string = utilityHelper.getEffectiveStringValue(cell.getOldValue(), rowData, field);
        var newEffectiveValue: string = utilityHelper.getEffectiveStringValue(newValue, rowData, field);
        if ((prevEffectiveValue !== newEffectiveValue) || (newValue.length > 0 && utilityHelper.getEffectiveNumericValue(newValue) === 0)) {
            // Turn ON the dirty flag in redux
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
            updateCell(cell, cell.getTable());
            var newState : any = {};
            newState[props.tableName] = true; // this is actually has facts
            props.updateHasFacts(newState);
        }
        processEndEditValidations(cell);

    }

    const updateCell = function (cell: any, table: any) {

        var row: any;
        if (cell) {
            var key = getRowKey(cell);
            row = cell.getRow();
            row.update({ key: key });
            showErrors(row);
        }

        // Track the changes on Cells to an array of facts into MiscSlice
        if (props.affiliateCode) {
            utilityHelper.updateTableCell(props.tableName + "^" + props.affiliateCode, null, cell, table, dispatch);
        } else {
            utilityHelper.updateTableCell(props.tableName, null, cell, table, dispatch);
        }
        // ***************************************************************************
        if (cell) {
            row = cell.getRow();
            row.reformat();
        }
    }


    // ************************************************************* /*
    // General purpose functions                                     //
    // ************************************************************* /*
    function noDataDisabled(noData: boolean) {
        return true;
    }

    function getKeyByValue(object: any, value: string) {
        return Object.keys(object).find(key => object[key] === value);
    }

    const composeSelectFormatter = function (options: any) {

        return (cell: any) => {

            var currentValue = cell.getValue();
            var key = getKeyByValue(options, currentValue);

            if (key) {
                return currentValue;
            }

            if (!currentValue) {
                return currentValue;
            }

            return options[currentValue];
        }
    }

    const convertTypedDimensionValueToEditor = function (dr: DimensionReference, val: string): string {
        if (!dr) {
            return val;
        }
        var modVal: string = val;
        var axis = dr.axis;
        if (axis.typedDomain && axis.typedDomain.datatype) {

            var key: string = enums.conceptDatatype[axis.typedDomain.datatype];
            switch (key) {
                case enums.conceptDatatype.XBRLI_DATEITEMTYPE:
                    // We need to convert to US date from ISO date
                    modVal = utilityHelper.convertFromISODate(val);
                    break;
                case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                    modVal = val;  // should support % style better
                    break;
            }

        }
        return modVal;

    }

    // special logic to verify if a cell is editable or not
    // editable    --> return true
    // no editable --> return false
    const handleEditCheck = function (cell: any) {
        if (currentAfr && currentAfr.taxonomyType) {
            switch (currentAfr.taxonomyType) {
                case TaxonomyTypeEnum.COURT_REPORTING_29:
                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    return false;
            }
        }
        return true;
    }

    const showHeaderMenu = function (currentAfr: Afr | null) : boolean {
        if (isNoData()) {
            return false;
        }
        if (!currentAfr) {
            return false;
        }
        if (utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)) {
            return false;
        }
        switch (currentAfr.taxonomyType) {
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                return false;
                
            default:
                return true;
        }
    }
    // ************************************************************* /*
    // Grid Options                                                  //
    // ************************************************************* /*
    const newGridOptions = {
        layout: "fitColumns", // "fitDataStretch", // "fitDataTable", // "fitDataFill",
        layoutColumnsOnNewData: true,
        selectable: 1,
        validationMode: "highlight",
        selectableRollingSelection: false,
        scrollToRowPosition: "center",
        height: "250",  // to be adjusted if another thing is decided
        index: "accountCode",
        cellEditCancelled: handleCancelEdit,
        cellEdited: handleEdited,
        cellClick: handleCellClick,
        validationFailed: (cell: any, value: any, validators: any) => handleValidationFailed(cell, value, validators),
        ...props.gridOptions

    }

    if (props.tableName === enums.tableName.bonds) {
        title = "Bonds"
    }

    /* PAINTING THE COLUMNS */
    const defaultColumns: any = [];
    var isLocked = utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin);
    if (!isLocked) {
        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                isLocked = true;
                break;
        }
    }
    /* adding the delete button column to the grid */
    if (!isLocked) {
        defaultColumns.push({
            rowHandle: true,
            formatter: showDelete,
            cellClick: handleDelete,
            headerSort: false, frozen: true, width: 30, minWidth: 30, headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
        })
    }
    switch (props.taxonomyType) {
        case TaxonomyTypeEnum.COURT_REPORTING_939:
            break;

        default:
            defaultColumns.push({
                rowHandle: true, formatter: showIcons,
                headerSort: false, frozen: true, width: 32, minWidth: 32, headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
            })
            break;
    }
    var acctTable: FactTable | null = null;
    var typedDimensionMap: any = {};
    var rowdimFields: string[] = [];
    var conceptFields: string[] = [];
    if (currentAfr) {
        acctTable = getTable(currentAfr, props.tableName);

        if (acctTable) {
            var primaryAxis: string = acctTable.structure.rowHierarchy.axes[0].id;
            newGridOptions.index = primaryAxis;
            var numAxes = acctTable.structure.rowHierarchy.axes.length;
            for (var axis of acctTable.structure.rowHierarchy.axes) {
                if (!axis) {
                    continue;
                }
                var colDataType: string = "unknown";
                if (axis.typedDomain) {
                    typedDimensionMap[axis.id] = axis.typedDomain;
                    rowdimFields.push(axis.id + ":" + enums.conceptDatatype[axis.typedDomain.datatype]);
                    colDataType = enums.conceptDatatype[axis.typedDomain.datatype];
                } else {
                    rowdimFields.push(axis.id);
                }

                var columnSetting : any | null= null;
                if (isLocked) {
                    columnSetting = {
                        title: utilityHelper.insertSpacesInCamelCase(axis.name),
                        field: axis.id,
                        //width: 350,
                        validator: [{ type: customValidator }],
                        formatter: {}, // showErrorIcon,
                        formatterParams: {},
                        frozen: false,
                        headerSort: false,
                        headerHozAlign: "center",
                    };
                    // Don't do the rest of the processing here
                    switch (colDataType) {
                        case enums.conceptDatatype.XBRLI_DATEITEMTYPE:
                            columnSetting = {
                                ...columnSetting,
                                formatter: dateHelper.tabulatorDateFormatter()
                            }
                            break;
                        case enums.conceptDatatype.XBRLI_MONETARYITEMTYPE:
                        case enums.conceptDatatype.XBRLI_NONNEGATIVEINTEGERITEMTYPE:
                        case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                            columnSetting = { ...columnSetting, formatter: numberFormatter }
                            break;

                        default:
                            break;
                    }
                    defaultColumns.push(columnSetting);
                    continue;
                } else {
                    columnSetting = {
                        title: utilityHelper.insertSpacesInCamelCase(axis.name),
                        field: axis.id,
                        editor: "input",
                        editable: handleEditCheck,
                        editorParams: {},
                        //width: 350,
                        validator: [{ type: customValidator }],
                        formatter: {}, // showErrorIcon,
                        formatterParams: {},
                        frozen: false,
                        headerHozAlign: "center",
                        headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                        cellEditCancelled: handleCancelEdit,
                        cellEdited: handleEdited,
                        cellClick: handleCellClick,
                    };
                }

                /* If the data needs a drop down */
                if (axis.membersByYear && axis.membersByYear.length > 0) {

                    /* populate all the option into the dropdown */
                    const selectOptions : any[] = [];
                    var options: any = {}
                    switch (props.taxonomyType) {
                        case TaxonomyTypeEnum.COURT_REPORTING_939:
                            for (var cropc of props.dimensionFilter) {
                                var cropcName = cropc.name;
                                selectOptions.push({ value: cropc.id, label: cropcName });
                                options[cropc.id] = cropcName;

                            }
                            break;

                        default:
                            for (var opc of axis.membersByYear) {
                                var opcName = utilityHelper.insertSpacesInCamelCase(opc.name);
                                //selectOptions[opc.code] = opc.name;
                                selectOptions.push({ value: opc.code, label: opcName });
                                options[opc.code] = opcName;

                            }
                            break;
                    }

                    columnSetting = {
                        ...columnSetting, editor: "select", editorParams: { values: options },
                        formatter: composeSelectFormatter(options), headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                    }

                } else {
                    if (axis.typedDomain && axis.typedDomain.datatype) {

                        var key: string = enums.conceptDatatype[axis.typedDomain.datatype];
                        switch (key) {
                            case enums.conceptDatatype.XBRLI_DATEITEMTYPE:
                                columnSetting = {
                                    ...columnSetting,
                                    editor: "date",
                                    editorParams: {
                                        format: "iso", // the format of the date value stored in the cell
                                    },
                                    formatter: dateHelper.tabulatorDateFormatter(), headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                                }
                                break;
                            case enums.conceptDatatype.XBRLI_MONETARYITEMTYPE:
                            case enums.conceptDatatype.XBRLI_NONNEGATIVEINTEGERITEMTYPE:
                            case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                                columnSetting = { ...columnSetting, formatter: numberFormatter, headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null, }
                                break;

                            default:
                                columnSetting = {
                                    ...columnSetting, headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                                    editorParams: { search: true, elementAttributes: { maxlength: "2000" } },
                                }
                        }

                    }


                }

                defaultColumns.push(columnSetting);


            }


            // Note - it is possible for the requested account table to not be present in this AFR
            // However that should be deal with upstream so the option doe snot appear
            for (var tbeGroup of acctTable.structure.nthlevelcolumnHierarchy) {
                var t : any | null                            = null;

                if (tbeGroup.sublevels) {
                    for (var tbeCol of tbeGroup.sublevels) {
                        t = tbeCol.conceptaspect.id;
                        conceptFields.push(t);
                        var key: string = enums.conceptDatatype[tbeCol.conceptaspect.datatype];
                        if (isLocked) {
                            switch (key) {
                                case enums.conceptDatatype.XBRLI_NONNEGATIVEINTEGERITEMTYPE:
                                    defaultColumns.push({
                                        title: tbeCol.label,
                                        field: t,
                                        headerSort: false,
                                        validator: [{ type: customValidator }],
                                        headerHozAlign: "right",
                                        hozAlign: "right",
                                        formatter: integerFormatter
                                    });
                                    break;
                                case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                                    defaultColumns.push({
                                        title: tbeCol.label,
                                        field: t,
                                        headerSort: false,
                                        validator: [{ type: customValidator }],
                                        headerHozAlign: "right",
                                        hozAlign: "right",
                                        formatter: percentFormatter
                                    });
                                    break;
                                default:
                                    defaultColumns.push({
                                        title: tbeCol.label,
                                        field: t,
                                        headerSort: false,
                                        validator: [{ type: customValidator }],
                                        headerHozAlign: "right",
                                        hozAlign: "right",
                                        formatter: "money", formatterParams: { symbol: "$", precision: 0 },
                                    });
                                    break;
                            }
                        } else {
                            switch (key) {
                                case enums.conceptDatatype.XBRLI_NONNEGATIVEINTEGERITEMTYPE:
                                    defaultColumns.push({
                                        title: tbeCol.label,
                                        field: t,
                                        headerSort: false,
                                        editor: "input",
                                        editable: handleEditCheck,
                                        validator: [{ type: customValidator }],
                                        headerHozAlign: "right",
                                        hozAlign: "right",
                                        formatter: integerFormatter,
                                        cellEditCancelled: handleCancelEdit,
                                        cellEdited: handleEdited,
                                        cellClick: handleCellClick,
                                        headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                                    });
                                    break;
                                case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                                    defaultColumns.push({
                                        title: tbeCol.label,
                                        field: t,
                                        headerSort: false,
                                        editor: "input",
                                        editable: handleEditCheck,
                                        validator: [{ type: customValidator }],
                                        headerHozAlign: "right",
                                        hozAlign: "right",
                                        formatter: percentFormatter,
                                        cellEditCancelled: handleCancelEdit,
                                        cellEdited: handleEdited,
                                        cellClick: handleCellClick,
                                        headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                                    });
                                    break;
                                default:
                                    defaultColumns.push({
                                        title: tbeCol.label,
                                        field: t,
                                        headerSort: false,
                                        editor: "input",
                                        editable: handleEditCheck,
                                        editorParams: { mask: "*999999999999" },
                                        validator: [{ type: customValidator }],
                                        headerHozAlign: "right",
                                        hozAlign: "right",
                                        formatter: "money", formatterParams: { symbol: "$", precision: 0 },
                                        cellEditCancelled: handleCancelEdit,
                                        cellEdited: handleEdited,
                                        cellClick: handleCellClick,
                                        headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
                                    });
                                    break;
                            }
                        }


                    }

                }

            }
        }
    }
    if (defaultColumns.length === 0) {
        defaultColumns.push({
            title: "Name",
            field: "accountCode",
            editor: "input",
            editable: handleEditCheck,
            editorParams: {
                search: true,
                elementAttributes: {
                    maxlength: "2000", //set the maximum character length of the input element to 2000 characters
                }
            },
            width: 350,
            validator: [{ type: customValidator }],
            formatter: showIcons,
            frozen: false,
            headerHozAlign: "center",
            headerContextMenu: showHeaderMenu(currentAfr) ? headerMenu : null,
            cellEditCancelled: handleCancelEdit,
            cellEdited: handleEdited,
            cellClick: handleCellClick,
        });
    }

    const generateTableData = function (acctTable: FactTable | null): any {
        // Added a terminal pip character to the filter so the delimiter can be part of the search key and eliminate incorrect partial matching like
        // CR_939_Other and CR_939_OtherCourtInnovations
        var dimFilter = props.dimensionFilter ? props.dimensionFilter.map((x: Concept) => x.id).join("|") + "|" : "";
        var tabledata: any = [];
        if (acctTable) {

            for (var row of acctTable.rows) {
                if (row.facts.length === 0) {
                    continue;
                }
                var excludeRow = false;
                var rowDimMap: any = {};
                for (var drMap of row.dimensions) {
                    rowDimMap[drMap.axis.id] = drMap;
                    // NOTE - The join on an empty array still leaves a single delimiater character, hence the need to change the length test to > 1
                    if (drMap.member && dimFilter.length > 1) {
                        if ( dimFilter.indexOf(drMap.member.id + "|") < 0) {
                            excludeRow = true;
                        }
                    }
                }
                if (excludeRow) {
                    continue;
                }
                // If we have an affiliate code then we are representing facts for one affiliate, to filter for those fact rows that match the current affiliate
                if (rowDimMap.hasOwnProperty("ReportingUnitAxis")) {
                    if (!props.affiliateCode || props.affiliateCode.length === 0) {
                        continue;
                    }
                    if (rowDimMap["ReportingUnitAxis"].member.code !== props.affiliateCode) {
                        continue;
                    }
                }
                var dr = row.dimensions[0];

                var accountLabel = dr.typedContent;
                var accountId = (dr.typedContent ? dr.typedContent : "");
                if (!accountLabel && dr.member ) {
                    accountLabel = dr.member.name;
                    accountId = dr.member.name;
                }
                var rowid = props.tableName + "|" + accountId;

                var nextRow: any = {
                    id: rowid, account: accountLabel, accountId: accountId, accountCode: accountId, dimensionFields: rowdimFields, conceptFields: conceptFields, key: ""
                }
                var key = "";
                for (var axis of acctTable.structure.rowHierarchy.axes) {
                    if (rowDimMap.hasOwnProperty(axis.id)) {
                        dr = rowDimMap[axis.id];
                        var val = "";
                        if (typedDimensionMap.hasOwnProperty(dr.axis.id)) {
                            // This is a typed member - so get the typedconted
                            val = dr.typedContent ? convertTypedDimensionValueToEditor(dr, dr.typedContent) : "";
                        } else {
                            val = dr.member ? dr.member.name : "";  // dr.member.code;
                        }
                        nextRow[axis.id] = val;
                        key = key + val + "|";
                    }
                }
                nextRow["key"] = utilityHelper.generateGuid(); //key;
                // Now add the row dimension qualifiers

                /* If any fact exist then it will be linked using the dimension[0].member.id */
                for (var fact of row.facts) {
                    var colcode = fact.concept.id;
                    nextRow[colcode] = fact.value;
                }
                tabledata.push(nextRow);

            }
             return tabledata;
        }

    }

    React.useEffect(() => {

        // reset the states when destroying the component
        return function cleanup() {

            // Saving pending changes to AfrSlice
            utilityHelper.saveDeferredChanges(dispatch);

        }
    }, []);

    React.useEffect(() => {
        // Saving pending changes to AfrSlice
        utilityHelper.saveDeferredChanges(dispatch);
        var emptyErrors: Array<ErrorGrid> = [];
        var newState: any = props.noData; //props.affiliateCode ? generateAffiliateNoDataState(currentAfr, props.affiliateCode, props.noDataState) : generateLocalStateFromEventProperties(currentAfr, [props.noDataState]);
        setState(newState);
        var noProjectsDeclared = newState[props.noDataState]
        dispatch(updateSupplementalGridErrors(emptyErrors));
        var tData = [];
        if (currentAfr) { //&& !noProjectsDeclared) {
            tData = generateTableData(getTable(currentAfr, props.tableName));
        }
        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.AFR:
                var pHolder = "Right Click The Table Header To Add A New Row";
                if (noProjectsDeclared) {
                    if (props.noDataState.indexOf("Bonds") >= 0) {
                        pHolder = "You must uncheck the 'No Bonds' option to Add New Rows";
                    } else if (props.noDataState.indexOf("Projects") >= 0) {
                        pHolder = "You must uncheck the 'No Construction Projects' option to Add New Rows";
                    }
                }
                tabulatorRef.current = new Tabulator("#" + props.gridId, {
                    data: tData,
                    columns: defaultColumns,
                    height: "300",
                    layout: "fitColumns",
                    layoutColumnsOnNewData: true,
                    selectable: 1,
                    selectableRollingSelection: false,
                    scrollToRowPosition: "center",
                    rowContextMenu: isLocked ? null : rowMenu,
                    placeholder: pHolder
                }).on("rowClick", handleRowClick);
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_939:
                tabulatorRef.current = new Tabulator("#" + props.gridId, {
                    data: tData,
                    columns: defaultColumns,
                    layout: "fitColumns",
                    layoutColumnsOnNewData: true,
                    selectable: 1,
                    selectableRollingSelection: false,
                    scrollToRowPosition: "center",
                    rowContextMenu: isLocked ? null : rowMenu,
                    placeholder: "To input financial information, upload the 939.185 Spreadsheet on the Documents screen.",
                }).on("rowClick", handleRowClick);
                break;

            default:
                tabulatorRef.current = new Tabulator("#" + props.gridId, {
                    data: tData,
                    columns: defaultColumns,
                    layout: "fitColumns",
                    layoutColumnsOnNewData: true,
                    selectable: 1,
                    selectableRollingSelection: false,
                    scrollToRowPosition: "center",
                    rowContextMenu: isLocked ? null : rowMenu,
                    placeholder: "Right Click The Table Header To Add A New Row",
                }).on("rowClick", handleRowClick);
                break;
        }
    }, [props.tableName, props.affiliateCode, props.noData]);


    return (
        <>
            <Row>
                <Col md="12">
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <div id={props.gridId} ref={ele => { tabulatorRef.current = ele }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <ShowSupplementalGridErrorList />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>
            </Row>


        </>


    );
}


export { RowDimensionEditorGrid };


